import React from "react";
import { pure } from "recompose";

import OnePanel from "./OnePanel";
import Text from "./Text";
import { moneyFormat } from "./format";

const FinancingAnalysis = pure(({ ceo, competitiveAnalysis, teamId }) => (
  <OnePanel title="Financing Analysis">
    <Text>
      This section we are going to review Head of Finance decisions and how they
      impact your Income Statement.
    </Text>
    <Text>
      Head of Finance raised{" "}
      {moneyFormat(ceo.team["stock_issuance"] + ceo.team["debt_borrowed"])} in
      capital to finance the business and{" "}
      {moneyFormat(-(ceo.team["stock_repurchase"] + ceo.team["debt_repaid"]))}{" "}
      was returned to investors.
    </Text>
    <Text>
      {(
        ceo.team["debt_borrowed"] + ceo.team["stock_issuance"] > 0
        ? (ceo.team["debt_borrowed"] / (ceo.team["debt_borrowed"] + ceo.team["stock_issuance"]) * 100) : 0
      ).toFixed(1)}
      % of the capital that was raised was in the form of debt while the
      remaining was in equity.
    </Text>
  </OnePanel>
));

export default FinancingAnalysis;



// WEBPACK FOOTER //
// ./src/components/analysis/FinancingAnalysis.js